import { render, staticRenderFns } from "./LoginOrRegist.vue?vue&type=template&id=865a3d2a&scoped=true"
import script from "./LoginOrRegist.vue?vue&type=script&lang=ts"
export * from "./LoginOrRegist.vue?vue&type=script&lang=ts"
import style0 from "./LoginOrRegist.scss?vue&type=style&index=0&id=865a3d2a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865a3d2a",
  null
  
)

export default component.exports